<template>
        <div class="password-container ">
            <form v-on:submit.prevent="validateBeforeSubmit">
              <div class="form-group text-left">
                <label class="custom-label control-label">Password</label>
                <input class="form-control password-field" type="password" name="password" v-model.trim="password">
                <span class="error help-block" ></span>
              </div>
              <div class="text-danger" v-if="error"><p>Incorrect password.</p></div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </form>
        </div>
</template>



<script>
//import storageHelper from '';

export default {
  name: 'Protected',

  components: {
    //AdminTable,
  },
  data: () => ({
    //
  }),
};
</script>
